import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      const label = this.props.label || "questa pagina";
      return (
        <div className="max-w-xl mx-auto mt-16 p-6 border border-red-200 bg-red-50 rounded-md text-center space-y-3" data-testid="error-boundary">
          <div className="text-3xl">⚠️</div>
          <h2 className="font-heading text-xl font-bold text-red-800">Si è verificato un problema</h2>
          <p className="text-sm text-red-700">
            Errore nel caricamento di {label}. Ricarica la pagina per riprovare.
          </p>
          <button
            onClick={() => window.location.reload()}
            data-testid="error-boundary-reload"
            className="px-4 py-2 bg-red-600 text-white rounded-md text-sm hover:bg-red-700"
          >Ricarica pagina</button>
          {process.env.NODE_ENV !== "production" && this.state.error && (
            <details className="text-left mt-4 text-xs text-red-800 bg-white p-3 rounded border border-red-100">
              <summary className="cursor-pointer">Dettagli tecnici</summary>
              <pre className="whitespace-pre-wrap mt-2">{String(this.state.error?.stack || this.state.error)}</pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
